var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a854a03b-0c93-4318-9d5b-0c20717faae5",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 398 314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M244.39999,155.1012c3.70001,0,7.29999-.79999,10.70001-1.90002,0,.70001,.09998,1.29999,.09998,2,0,31-25.19995,56.20001-56.19995,56.20001-3.22803,0-6.3869-.28711-9.46533-.80988l-26.36938,28.0661c10.99634,4.72418,23.10913,7.34375,35.83466,7.34375,50.20001,0,90.90002-40.69995,91-91,0-14.74707-3.51123-28.66644-9.73389-40.97937l-38.48639,40.96277c.86475,.07098,1.73682,.11664,2.6203,.11664Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.89999,155.20117c0-31.09998,25.09998-56.20001,56.09998-56.20001,4.216,0,8.30292,.47693,12.23859,1.34894l26.17242-27.85663c-11.67517-5.44592-24.69031-8.49231-38.41101-8.49231-50.19995,0-90.89996,40.80005-90.89996,91,0,15.73218,3.98175,30.52496,10.98993,43.42737l25.99731-27.67023c-1.41412-4.94012-2.18726-10.15479-2.18726-15.55713Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.10001,155.00116c0-50.19995,40.70001-91,90.89996-91,13.7207,0,26.73584,3.04639,38.41101,8.49231l22.60352-24.05804c-19.42816-5.36487-39.88647-8.23425-61.01453-8.23425C113.99997,40.20117,39.89999,86.50116,.19998,155.1012c19.73029,34.09314,47.95972,62.67444,81.79852,82.8056l37.09143-39.47827c-7.00818-12.9024-10.98993-27.69519-10.98993-43.42737Z",
    style: {
      fill: "#255399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.19016,73.65747l-37.92407,40.36432c6.22266,12.31293,9.73389,26.2323,9.73389,40.97937-.09998,50.30005-40.79999,91-91,91-12.72552,0-24.83832-2.61957-35.83466-7.34375l-22.42181,23.86456c18.59949,4.87714,38.12134,7.47919,58.25647,7.47919,85,0,159-46.29999,198.80005-114.89996-19.33752-33.33051-46.77356-61.39459-79.60986-81.44373Z",
    style: {
      fill: "#255399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.99997,99.00116c-31,0-56.09998,25.10004-56.09998,56.20001,0,5.40234,.77313,10.617,2.18726,15.55713l66.15131-70.4082c-3.93567-.87201-8.02258-1.34894-12.23859-1.34894Z",
    style: {
      fill: "#255399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.00003,211.40118c31,0,56.19995-25.20001,56.19995-56.20001,0-.70001-.09998-1.29999-.09998-2-3.40002,1.10004-7,1.90002-10.70001,1.90002-.88348,0-1.75555-.04565-2.6203-.11664l-52.245,55.60675c3.07843,.52277,6.2373,.80988,9.46533,.80988Z",
    style: {
      fill: "#255399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.37332,.92676C231.66353,93.21546,137.30497,193.64516,50.61746,285.91016l28.90918,27.16309C166.68726,220.30451,260.15546,120.82232,347.2825,28.08936L318.37332,.92676Z",
    style: {
      fill: "#255399"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.5a3bcc64d8c1f84e53131ee49cfca960.svg";
export { ForwardRef as ReactComponent };